import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

const selectors = {
  block: "[data-pd]",
  image: "[data-pd-image]",
  navImage: "[data-pd-image-nav]",
  size: "[data-pd-size]",
  format: "[data-pd-format]",
  logos: "[data-pd-logos]",
};

const initLogosSwiper = (container) =>
  new Swiper(container.querySelector(selectors.logos), {
    slidesPerView: "auto",
    spaceBetween: 16,
    autoplay: true,
    rewind: true,

    breakpoints: {
      1024: {
        spaceBetween: 48,
      },
    },
  });

const initNavImage = (image, navImage) => {
  navImage.addEventListener("click", () => image.setAttribute("src", navImage.value));
};

const setFormat = (activeIndex, sizes, navImages) => {
  sizes.forEach((size, index) => size.classList[index === activeIndex ? "add" : "remove"]("active"));
  navImages.forEach((navImage, index) => {
    if (index !== activeIndex) return;

    navImage.click();
  });
};

const initFormat = (format, index, sizes, navImages) => {
  format.addEventListener("click", () => setFormat(index, sizes, navImages));
};

const initBlock = (block) => {
  const image = block.querySelector(selectors.image);
  const navImages = block.querySelectorAll(selectors.navImage);
  const sizes = block.querySelectorAll(selectors.size);
  const formats = block.querySelectorAll(selectors.format);

  const searchParams = new URLSearchParams(window.location.search);
  const queryFormat = searchParams.get("format");
  const queryIndex = [...formats].findIndex((format) => format.dataset.pdFormat === queryFormat);

  navImages?.forEach((navImage) => initNavImage(image, navImage));
  formats?.forEach((format, index) => initFormat(format, index, sizes, navImages));

  Swiper.use([Autoplay]);

  initLogosSwiper(block);

  formats?.[queryIndex > -1 ? queryIndex : 0].click();
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
